export default "__VITE_ASSET__BxMjQZBY__"